<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            Postage Selling Price
          </h6>
          <div class="element-box">
            <div class="element-info my-0">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-mail">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Postage Selling Price
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <b-form-group class="col-lg-4 pl-0">
                <b-input-group>
                  <b-input-group-prepend>
                    <label class="input-group-text"> Client </label>
                  </b-input-group-prepend>
                  <b-form-select v-model="client" :options="clients" value-field="short_name" text-field="postroom_label" @change="onClientChange">
                    <template #first>
                      <b-form-select-option :value="null" disabled> Select the client </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="row">
              <ResponseInfo v-if="getResponseInfo.responseName == 'clientPostageSellingPrices'" class="px-0"/>
              <div class="col-lg-12 px-0" v-if="client">
              <b-card no-body>
                <b-tabs pills card>
                  <b-tab v-for="tab in tabs" :title="tab.title" :active="tab == activeTab" @click.prevent="setActiveTab(tab)">
                    <b-table id="posting-tracker-table" responsive striped hover bordered :fields="fields" :busy.sync="loading" :items="clientPostageSellingPrices" :show-empty="true">

                      <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="clientPostageSellingPrices">
                        <vcl-table :rows="3" :columns="fields.length"></vcl-table>
                      </template>

                      <template v-slot:cell(post_type)="data">
                        <b-form-select v-model="data.item.post_type" :options="postTypes" value-field="value" text-field="value" size="sm">
                          <template #first>
                            <b-form-select-option :value="null" disabled> Select the post type </b-form-select-option>
                          </template>
                        </b-form-select>
                      </template>

                      <template v-slot:cell(env_type)="data">
                        <b-form-select v-model="data.item.env_type" :options="tabEnvTypes" value-field="id" text-field="type" size="sm">
                          <template #first>
                            <b-form-select-option :value="null" disabled> Select the envelope type </b-form-select-option>
                          </template>
                        </b-form-select>
                      </template>

                      <template v-slot:cell(isSurcharge)="data">
                        <div class="checkbox-align-center">
                          <b-form-checkbox
                              v-model="data.item.isSurcharge"
                              :value="1"
                              :unchecked-value="0"
                              button
                              button-variant="primary"
                          >
                             {{ data.item.isSurcharge ? '+' : '-' }}
                          </b-form-checkbox>
                        </div>
                      </template>

                      <template v-slot:cell(discount)="data">
                        <div class="input-group input-group-sm">
                          <b-form-input type="number" min="0.00" step="0.01" v-model="data.item.discount" class="form-control" />
                        </div>
                      </template>

                      <template v-slot:cell(discount_type)="data">
                        <b-form-select v-model="data.item.discount_type" :options="discountTypes" value-field="value" text-field="value" size="sm">
                          <template #first>
                            <b-form-select-option :value="null" disabled> Select the discount type </b-form-select-option>
                          </template>
                        </b-form-select>
                      </template>

                      <template v-slot:cell(actions)="data">
                        <div class="btn btn-sm btn-primary" @click="updateClientPostageSellingPrice(data.item)">Update</div>
                        <div class="btn btn-sm btn-danger" @click="openDeleteModal(data.item.id, $event.target)">Delete</div>
                      </template>

                      <template slot="bottom-row" v-if="tabEnvTypes && clientBatchTypes">
                        <td>
                          <b-form-select v-model="newItem.batch_type" :options="clientBatchTypes" value-field="id" text-field="name" >
                            <template #first>
                              <b-form-select-option :value="null" disabled> Select the batch type </b-form-select-option>
                            </template>
                          </b-form-select>
                        </td>

                        <td>
                          <b-form-select v-model="newItem.post_type" :options="postTypes" value-field="value" text-field="value">
                            <template #first>
                              <b-form-select-option :value="null" disabled> Select the post type </b-form-select-option>
                            </template>
                          </b-form-select>
                        </td>

                        <td>
                          <b-form-select v-model="newItem.env_type" :options="tabEnvTypes" value-field="id" text-field="type">
                            <template #first>
                              <b-form-select-option :value="null" disabled> Select the envelope type </b-form-select-option>
                            </template>
                          </b-form-select>
                        </td>

                        <td>
                          <div class="checkbox-align-center">
                            <b-form-checkbox
                                v-model="newItem.isSurcharge"
                                :value="1"
                                :unchecked-value="0"
                                button
                                button-variant="primary">
                              {{ newItem.isSurcharge ? '+' : '-' }}
                            </b-form-checkbox>
                          </div>
                        </td>

                        <td>
                          <div class="input-group">
                            <b-form-input type="number" min="0.00" step="0.01" v-model="newItem.discount" class="form-control" />
                          </div>
                        </td>

                        <td>
                          <b-form-select v-model="newItem.discount_type" :options="discountTypes" value-field="value" text-field="value">
                            <template #first>
                              <b-form-select-option :value="null" disabled> Select the discount type </b-form-select-option>
                            </template>
                          </b-form-select>
                        </td>

                        <td>
                          <span> {{tab.code}} </span>
                        </td>

                        <td>
                        </td>

                        <td>
                          <div class="btn btn-success" @click="addClientPostageSellingPrice">Add</div>
                        </td>
                      </template>
                    </b-table>
                  </b-tab>
                </b-tabs>
              </b-card>
              </div>
              <div class="col-lg-12" v-else>
                <p class="text-center text-muted mt-3">To see 'Postage Selling Price' settings, please, select the client above.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDeleteItem :modal="deletePostageSellingPriceModal" @hide="resetDeleteModal" @deleteItem="deleteClientPostageSellingPrice"/>
    <div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import { VclTable } from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"
import ModalDeleteItem from "@/components/Helper_Components/ModalDeleteItem.vue";

export default {
  name: 'PostageSellingPrice',
  components: {
    ModalDeleteItem,
    VclTable,
    ResponseInfo
  },
  data() {
    return {
      newItem: {
        batch_type: null,
        post_type: null,
        env_type: null,
        isSurcharge: 0,
        discount: '0.00',
        discount_type: null,
        currency: null,
        client: null
      },
      activeTab: null,
      client: null,
      fields: [
        {key: 'batch_name', label: 'Batch type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'post_type', label: 'Post class', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'env_type', label: 'Envelope type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'isSurcharge', label: 'Surcharge (-/+)', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'discount', label: 'Discount', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'discount_type', label: 'Discount type', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'currency', label: 'Currency', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'price', label: 'Min Price', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'actions', label: 'actions', sortable: true, thClass: 'hover-pointer brand-color'},
      ],
      currentPage: 1,
      perPage: 20,
      loading: false,
      tabs: [
        { title: 'UK', code: 'GBP'},
        { title: 'Germany', code: 'EUR'},
        { title: 'USA', code: 'USD'},
        { title: 'Australia', code: 'AUD'},
        { title: 'Singapore', code: 'SGD'},
      ],
      postTypes: [
        {value: '1st Class'},
        {value: '2nd Class'},
        {value: 'Mailsort 1'},
        {value: 'Mailsort 2'},
      ],
      discountTypes: [
        {value: '%'},
        {value: 'p'},
      ],
      deletePostageSellingPriceModal: {
        itemId: null,
        title: 'Delete selected postage selling price',
        id: 'deletePostageSellingPriceModal',
        question: 'Delete selected postage selling price - are you sure?'
      },
      overlayBackgroundDisplay: false
    }
  },
  methods: {
    deleteClientPostageSellingPrice(done) {
      this.$store.dispatch('deleteClientPostageSellingPrice', {
        itemId: this.deletePostageSellingPriceModal.itemId
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostageSellingPrices()
        }
        this.resetDeleteModal()
      }).finally(() => {
        done();
      })
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.loadClientPostageSellingPrices()
    },
    onClientChange() {
      this.activeTab = this.tabs[0]
      this.loadClientPostageSellingPrices()
    },
    loadClients() {
      this.$store.dispatch('loadClientsByEnv')
    },
    loadClientPostageSellingPrices() {
      this.resetNewItem()
      this.loading = true
      this.$store.dispatch('loadClientPostageSellingPrices', {
        client: this.client,
        tabCode: this.activeTab.code
      }).finally(() => {
        this.loading = false
      })
    },
    openDeleteModal(postageSellingPriceId, button) {
      this.deletePostageSellingPriceModal.itemId = postageSellingPriceId
      this.overlayBackgroundDisplay = true
      this.$root.$emit('bv::show::modal', this.deletePostageSellingPriceModal.id, button)
    },
    resetDeleteModal() {
      this.$root.$emit('bv::hide::modal', this.deletePostageSellingPriceModal.id)
      this.overlayBackgroundDisplay = false
      this.deletePostageSellingPriceModal.itemId = null
    },
    updateClientPostageSellingPrice(item) {
      this.$store.dispatch('updateClientPostageSellingPrice', {
        item: item
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostageSellingPrices()
        }
      })
    },
    addClientPostageSellingPrice() {
      this.newItem.currency = this.activeTab.code
      this.newItem.client = this.client

      this.$store.dispatch('addClientPostageSellingPrice', {
        item: this.newItem
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostageSellingPrices()
        }
      })
    },
    resetNewItem() {
      this.newItem = {
        batch_type: null,
        post_type: null,
        env_type: null,
        isSurcharge: 0,
        discount: '0.00',
        discount_type: null,
        currency: null,
        client: null
      }
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    clients: {
      get() {
        return this.$store.getters.getClientsByEnv
      }
    },
    clientPostageSellingPrices: {
      get() {
        return this.$store.getters.getClientPostageSellingPrices
      }
    },
    clientBatchTypes: {
      get() {
        return this.$store.getters.getClientBatchTypes
      }
    },
    tabEnvTypes: {
      get() {
        return this.$store.getters.getTabEnvTypes
      }
    },
  },
  created() {
    this.loadClients()
    this.$store.dispatch('alertClearResponse')
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.checkbox-align-center {
  display: flex;
  justify-content: center;
}
</style>
